import React from "react";

import { Badge } from "../../../../../components/badge";
import { Card } from "../../../../../components/card";
import QuestionTypeIcon from "../icons/QuestionTypeIcon";
import { QUESTION_TYPE_COMPONENTS, noopRendererProps } from "./question-authoring";
import type { QuestionTypeRendererProps } from "./question-authoring/shared";
import type { SurveyQuestion } from "../../types/survey.types";

interface SurveyQuestionPreviewCardProps {
  question: SurveyQuestion;
  index: number;
  questionTypeLabel?: string;
  requiredLabel?: string;
}

export function SurveyQuestionPreviewCard({
  question,
  index,
  questionTypeLabel,
  requiredLabel = "Required",
}: SurveyQuestionPreviewCardProps) {
  const Renderer = QUESTION_TYPE_COMPONENTS[
    question.type as keyof typeof QUESTION_TYPE_COMPONENTS
  ] as React.ComponentType<QuestionTypeRendererProps>;

  return (
    <Card className="mb-4 p-4">
      <div className="flex items-start gap-3 mb-4">
        <div
          className="w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0 mt-1"
          style={{ backgroundColor: "#F2FCFA" }}
        >
          <QuestionTypeIcon type={question.type} />
        </div>

        <div className="flex-1">
          <div className="flex flex-wrap items-center gap-2 mb-2">
            <span className="text-sm font-medium text-gray-900 dark:text-white">
              {index + 1}. {question.data.question}
            </span>
            {question.is_required && (
              <Badge variant="destructive" className="text-xs dark:bg-red-600 dark:text-white">
                {requiredLabel}
              </Badge>
            )}
            <Badge
              variant="outline"
              className="text-xs capitalize dark:border-gray-500 dark:text-gray-200 dark:bg-gray-700"
            >
              {questionTypeLabel ?? question.type.replace("_", " ")}
            </Badge>
          </div>
        </div>
      </div>

      {Renderer ? (
        <Renderer
          question={question}
          index={index}
          isPreview
          {...noopRendererProps}
        />
      ) : null}
    </Card>
  );
}

export default SurveyQuestionPreviewCard;
